import { inject, Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from '@htx/environment';
import { DsaUser } from './dsa-user.model';

@Injectable({
  providedIn: 'root'
})
export class DsaUserService {

  private httpClient = inject(HttpClient);
  private readonly baseUrl = `${environment.backendUrl}/api/dsa-users`;

  findAll(): Observable<DsaUser[]> {
    return this.httpClient.get<DsaUser[]>(this.baseUrl);
  }

  create(user: DsaUser): Observable<DsaUser> {
    return this.httpClient.post<DsaUser>(this.baseUrl, user);
  }

  update(iamId: string, user: DsaUser): Observable<DsaUser> {
    return this.httpClient.put<DsaUser>(`${this.baseUrl}/${iamId}`, user);
  }

  deactivate(iamId: string): Observable<void> {
    return this.httpClient.patch<void>(`${this.baseUrl}/${iamId}/deactivate`, {});
  }

  activate(iamId: string): Observable<void> {
    return this.httpClient.patch<void>(`${this.baseUrl}/${iamId}/activate`, {});
  }

  delete(iamId: string): Observable<void> {
    return this.httpClient.delete<void>(`${this.baseUrl}/${iamId}`);
  }
}
